import type { LiveMediaState } from '../shared/media/LiveMediaAdapter';
import { connectionQualityLabel } from '../shared/i18n';

export type MobileLivePhase = 'DISCONNECTED' | 'CONNECTING' | 'READY' | 'LIVE' | 'RECOVERING';

export function secondsUntilLeaseLoss(lastHeartbeatAt: number | null, leaseTtlSeconds: number, now: number): number | null {
  if (lastHeartbeatAt === null) return null;
  return Math.max(0, Math.ceil((lastHeartbeatAt + leaseTtlSeconds * 1_000 - now) / 1_000));
}

export function mediaSummary(media: LiveMediaState): string {
  const parts: string[] = [connectionQualityLabel(media.quality)];
  if (media.latencyMs !== null) parts.push(`${Math.round(media.latencyMs)} мс`);
  if (media.packetLossPercent !== null) parts.push(`втрата ${media.packetLossPercent.toFixed(1)}%`);
  return parts.join(' · ');
}

export function canUseLiveTransport(phase: MobileLivePhase, connected: RTCPeerConnectionState): boolean {
  return phase === 'LIVE' && connected === 'connected';
}
